import { createContext, useContext, useEffect, useState } from "react";

const WorkspaceContext = createContext(null);
const KEY = "crm.workspace";

export function WorkspaceProvider({ children }) {
  const [workspace, setWorkspaceState] = useState(() => localStorage.getItem(KEY) || "amber");
  useEffect(() => { localStorage.setItem(KEY, workspace); }, [workspace]);
  const setWorkspace = (w) => setWorkspaceState(w === "berke" ? "berke" : "amber");
  return (
    <WorkspaceContext.Provider value={{ workspace, setWorkspace }}>
      {children}
    </WorkspaceContext.Provider>
  );
}

export const useWorkspace = () => useContext(WorkspaceContext);
